'use client';

import { Provider } from 'react-redux';
import { store } from './localization/store';
import { AppInitializer } from './tickets/AppInitializer';

export default function ClientProviders({ children }: { children: React.ReactNode }) {
  return (
    <Provider store={store}>
      <AppInitializer />
      {children}
    </Provider>
  );
}
